import React from 'react'

import { ParallaxProvider } from 'react-scroll-parallax'

import Layout from '../layouts/layout'
import { HeroInternal, Examples as ExamplesComponent } from '../components'

const ExamplesPage = () => (
  <Layout>
    <ParallaxProvider>
      <HeroInternal
        id="examples-hero"
        title="Seeing is believing"
        bg={`${process.env.GATSBY_SITE_ASSETS_URL}/images/hero-team@2x.png`}
        button={{ title: 'Take me to them!', url: '#examples', shadowed: true }}
        text="Our team works with thousands of clients including: design studios, agencies and startups.<br/> We focus on helping them with their web development processes and needs.<br/> Take a look at this fresh examples of completed projects."
      />

      <style>{`
        article .content > .subtitle {
          max-width: 700px !important;
        }
      `}</style>
    </ParallaxProvider>

    <ExamplesComponent internal />
  </Layout>
)

export default ExamplesPage
